// extracted by mini-css-extract-plugin
module.exports = {"container":"_2787e5dfdf--container--iViWW","heading":"_2787e5dfdf--heading--bJkDO","dropdown":"_2787e5dfdf--dropdown--FByen"};